module.exports = __webpack_public_path__ + "static/media/timer-reset.b5d0d33a.svg";